<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>用户</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button v-show="IsShowConfirm" @click="handleConfirm">
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="代码:" prop="code">
                          <el-input
                            id="code"
                            :readonly="IsReadonlyCode"
                            v-model="SelectData.code"
                            clearable
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="名称:" prop="name">
                          <el-input
                            id="name"
                            v-model="SelectData.name"
                            clearable
                            :readonly="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="昵称:" prop="nickName">
                          <el-input
                            id="nickName"
                            v-model="SelectData.nickName"
                            clearable
                            :readonly="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="手机号:" prop="phone">
                          <el-input
                            id="phone"
                            v-model="SelectData.phone"
                            clearable
                            :readonly="IsReadonly"
                            maxlength="11"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="单位名称:" prop="unitName">
                          <el-input
                            id="unitName"
                            v-model="SelectData.unitName"
                            clearable
                            :readonly="IsReadonly"
                            maxlength="11"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="岗位角色:" prop="station">
                          <el-select
                            v-model="SelectData.station"
                            placeholder="岗位角色"
                            :disabled="IsReadonly"
                          >
                            <el-option
                              v-for="item in stationList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="省-市-区" prop="provinceId">
                        <el-select
                          style="width: 10rem"
                          v-model="SelectData.provinceId"
                          filterable
                          placeholder="请选择省"
                          @change="ProvinceChange"
                          :disabled="IsReadonly"
                        >
                          <el-option
                            v-for="item in ProvinceList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>

                        <el-select
                          style="width: 10rem"
                          v-model="SelectData.cityId"
                          filterable
                          placeholder="请选择市"
                          @change="CityChange"
                          :disabled="IsReadonly"
                        >
                          <el-option
                            v-for="item in CityList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                        <el-select
                          style="width: 10rem"
                          v-model="SelectData.regionId"
                          placeholder="请选择区"
                          :disabled="IsReadonly"
                          filterable
                        >
                          <el-option
                            v-for="item in RegionList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="课时:" prop="classHour">
                          <el-input
                            id="classHour"
                            v-model="SelectData.classHour"
                            clearable
                            :readonly="IsReadonly"
                            type="number"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="密码:" prop="password">
                          <el-input
                            id="password"
                            type="password"
                            v-model="SelectData.password"
                            clearable
                            :readonly="IsReadonly || OpStatus == 'Modify'"
                          />
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item
                          label="注册方式:"
                          prop="type"
                          label-width="400"
                          label-position="right"
                        >
                          <el-radio
                            v-model="SelectData.type"
                            :label="0"
                            size="large"
                            :disabled="true"
                            >平台新增</el-radio
                          >
                          <el-radio
                            v-model="SelectData.type"
                            :label="1"
                            size="large"
                            :disabled="true"
                            >小程序注册</el-radio
                          >
                          <el-radio
                            v-model="SelectData.type"
                            :label="2"
                            size="large"
                            :disabled="true"
                            >平台导入</el-radio
                          >
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="邮箱:" prop="mail">
                          <el-input
                            id="mail"
                            v-model="SelectData.mail"
                            clearable
                            :readonly="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="期数:" prop="period">
                          <el-select
                            id="period"
                            v-model="SelectData.period"
                            placeholder="请选择期数"
                            :disabled="IsReadonly"
                            filterable
                            clearable
                          >
                            <el-option
                              v-for="item in periodOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="公司:" prop="companyId">
                          <el-select
                            v-model="SelectData.companyId"
                            placeholder="公司"
                            :disabled="IsReadonly"
                          >
                            <el-option
                              v-for="item in CompanyList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item
                          label="用户状态:"
                          prop="state"
                          label-width="400"
                          label-position="right"
                        >
                          <el-radio
                            v-model="SelectData.state"
                            :label="0"
                            size="large"
                            :disabled="IsReadonly"
                            >停用</el-radio
                          >
                          <el-radio
                            v-model="SelectData.state"
                            :label="1"
                            size="large"
                            :disabled="IsReadonly"
                            >启用</el-radio
                          >
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="备注:" prop="remark">
                          <el-input
                            id="remark"
                            v-model="SelectData.remark"
                            clearable
                            :readonly="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import { SelectUserById, ModifyUser, AddUser, GetUserPosts } from "@api/Company/ApiUser";

import { GetDataCompanyList } from "@api/Company/ApiCompany";
import { ProvinceList } from "@/assets/apiData/Province";

export default {
  name: "UserEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      SelectData: {},
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
      CompanyList: [],
      PageQuery: {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        pageSize: 1000,
      },
      stationList: [
        // {
        //   id: "分管负责人及专职安全管理人员",
        //   name: "分管负责人及专职安全管理人员",
        // },
        // {
        //   id: "班组长(含车间主任)",
        //   name: "班组长(含车间主任)",
        // },
        // {
        //   id: "重大危险源包保责任人",
        //   name: "重大危险源包保责任人",
        // },
      ],
      ProvinceList: [],
      CityList: [],
      RegionList: [],
      // 期数选项：1期到100期，值为字符串"1"到"100"，支持动态添加
      periodOptions: Array.from({ length: 100 }, (_, i) => ({
        label: `${i + 1}期`,
        value: String(i + 1),
      })),
    };
  },

  created() {
    this.ProvinceList = JSON.parse(JSON.stringify(ProvinceList.entities));
    this.ProvinceList.unshift({
      areaName: "-请选择-",
      code: "",
    });
    this.getRoleList();
  },
  mounted() {},
  methods: {
    getRoleList(){
      GetUserPosts().then(res=>{
        this.stationList = (res || []).map(item=>{
          return {
            id:item.postName,
            name:item.postName
          }
        });
      })
    },
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(id, type) {
      const _this = this;
      _this.IsReadonly = false;
      _this.IsShowConfirm = true;
      _this.OpStatus = type;
      _this.IsReadonlyCode = true;

      _this.loadData_InjuryTypeList();

      if (type == "Add") {
        _this.IsReadonlyCode = false;
        _this.SelectData = {
          state: 1,
          type: 0,
          period: "",
        };
        return;
      } else if (type == "Detail") {
        _this.IsReadonly = true;
        _this.IsShowConfirm = false;
      }
      SelectUserById(id).then(function (data) {
        let fieldList = ["provinceId", "cityId", "regionId"];
        for (let i in data) {
          if (fieldList.includes(i) && data[i] == 0) {
            delete data[i];
          }
        }
        _this.SelectData = data;
        _this.edit_loadProvince();
      });
    },
    edit_loadProvince() {
      var _this = this;

      _this.ProvinceList.map((x) => {
        if (x.id == _this.SelectData.provinceId) {
          _this.CityList = JSON.parse(
            JSON.stringify(x.children.filter((o) => o.level == 3))
          );
          _this.CityList.unshift({
            areaName: "-请选择-",
            id: "",
          });

          var cityId = _this.SelectData.cityId;
          var parentCode = _this.getCodeById(cityId);
          _this.RegionList = JSON.parse(
            JSON.stringify(
              x.children.filter(
                (o) => o.level == 4 && o.parentCode == parentCode
              )
            )
          );
          _this.RegionList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
    /**
     *获取公司
     */
    loadData_InjuryTypeList() {
      const _this = this;
      GetDataCompanyList(_this.PageQuery).then(function (data) {
        _this.CompanyList = data.entities;
      });
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    GetNameByDm(vaule) {
      var newArr = arr.filter((item) => item.prop == vaule);
      return newArr[0].label;
    },

    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
    handleConfirm() {
      var _this = this;
      if (!_this.validate()) return;
      if (_this.OpStatus == "Add") {
        AddUser(this.SelectData).then(function (data) {
          _this.$message.success("新增成功!");
          _this.$emit("handle-confirm");
        });
      } else if (_this.OpStatus == "Modify") {
        ModifyUser(this.SelectData).then(function (data) {
          _this.$message.success("编辑成功!");
          _this.$emit("handle-confirm");
        });
      }
    },
    validate() {
      if (!this.SelectData.code || this.SelectData.code == "") {
        this.$message.error("代码是必须的!");
        return false;
      }
      if (!this.SelectData.name || this.SelectData.name == "") {
        this.$message.error("名称是必须的!");
        return false;
      }
      if (!this.SelectData.phone || this.SelectData.phone == "") {
        this.$message.error("手机号是必须的!");
        return false;
      }
      if (!this.SelectData.password || this.SelectData.password == "") {
        this.$message.error("密码是必须的!");
        return false;
      }
      if (!this.SelectData.provinceId || this.SelectData.provinceId == "") {
        this.$message.error("请选择省!");
        return false;
      }
      if (!this.SelectData.cityId || this.SelectData.cityId == "") {
        this.$message.error("请选择市!");
        return false;
      }
      if (!this.SelectData.regionId || this.SelectData.regionId == "") {
        this.$message.error("请选择区!");
        return false;
      }
      return true;
    },
    ProvinceChange: function () {
      const _this = this;
      _this.SelectData.cityId = "";
      _this.SelectData.regionId = "";
      _this.ProvinceList.map((x) => {
        if (x.id == _this.SelectData.provinceId) {
          _this.CityList = JSON.parse(
            JSON.stringify(x.children.filter((o) => o.level == 3))
          );
          _this.CityList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
    CityChange() {
      const _this = this;
      _this.SelectData.regionId = "";
      _this.ProvinceList.map((x) => {
        if (x.id == _this.SelectData.provinceId) {
          var cityId = _this.SelectData.cityId;
          var parentCode = _this.getCodeById(cityId);
          _this.RegionList = JSON.parse(
            JSON.stringify(
              x.children.filter(
                (o) => o.level == 4 && o.parentCode == parentCode
              )
            )
          );
          _this.RegionList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
    getCodeById(id) {
      var code = "";
      var _this = this;
      _this.ProvinceList.map((x) => {
        if (x.id == _this.SelectData.provinceId) {
          x.children.forEach((o) => {
            if (o.id == id) {
              code = o.code;
              return;
            }
          });
        }
      });
      return code;
    },
  },
};
</script>

<style lang="scss" scoped >
.select-items {
  position: relative;
  display: flex;
}

.select-item {
  height: 50px;
  flex: 33.33%;
  display: flex;
  margin: 0 10px;
}
.item-lab {
  flex: 25%;
  line-height: 50px;
  display: flex;
  position: relative;
}

.item-input {
  flex: 75%;
}

.item-lab > label {
  align-items: flex-end;
  position: absolute;
  right: 5px;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
</style>
